/* src/app/layout/components/app.message.scss */
:root {
  --primary-color: var(--p-primary-color);
  --primary-color-text: var(--p-primary-contrast-color);
  --text-color: var(--p-text-color);
  --text-color-secondary: var(--p-text-muted-color);
  --surface-border: var(--p-content-border-color);
  --surface-card: var(--p-content-background);
  --surface-hover: var(--p-content-hover-background);
  --surface-overlay: var(--p-overlay-popover-background);
  --transition-duration: var(--p-transition-duration);
  --maskbg: var(--p-mask-background);
  --border-radius: var(--p-content-border-radius);
  --layout-section-transition-duration: 0.2s;
  --focus-ring-shadow: var(--p-focus-ring-shadow);
  --p-datatable-border-color: var(--p-content-border-color);
}
:root {
  --surface-ground: var(--p-surface-50);
}
:root[class*=app-dark] {
  --surface-ground: var(--p-surface-950);
}
.card {
  background-color: var(--surface-card);
  padding: 1rem;
  margin-bottom: 2rem;
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
}
.card:last-child {
  margin-bottom: 0;
}
.layout-topbar-dark {
  --topbar-bg: var(--p-surface-950);
  --topbar-menu-button-bg: var(--primary-color);
  --topbar-menu-button-text-color: var(--primary-color-text);
  --topbar-item-text-color: #ffffff;
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: var(--p-content-border-color);
}
.layout-topbar-light {
  --topbar-bg: #ffffff;
  --topbar-menu-button-bg: var(--primary-color);
  --topbar-menu-button-text-color: var(--primary-color-text);
  --topbar-item-text-color: var(--p-surface-500);
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: var(--p-content-border-color);
}
.layout-topbar-blue {
  --topbar-bg: #1E3C72;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #1E3C72;
  --topbar-item-text-color: #ffffff;
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: #1E3C72;
}
.layout-topbar-purple {
  --topbar-bg: #6f42c1;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #6f42c1;
  --topbar-item-text-color: #ffffff;
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: #6f42c1;
}
.layout-topbar-pink {
  --topbar-bg: #d63384;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #d63384;
  --topbar-item-text-color: #ffffff;
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: #d63384;
}
.layout-topbar-cyan {
  --topbar-bg: #0dcaf0;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #0dcaf0;
  --topbar-item-text-color: #ffffff;
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: #0dcaf0;
}
.layout-topbar-teal {
  --topbar-bg: #20c997;
  --topbar-menu-button-bg: #212529;
  --topbar-menu-button-text-color: #20c997;
  --topbar-item-text-color: #212529;
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: #20c997;
}
.layout-topbar-green {
  --topbar-bg: #198754;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #198754;
  --topbar-item-text-color: #ffffff;
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: #198754;
}
.layout-topbar-yellow {
  --topbar-bg: #ffc107;
  --topbar-menu-button-bg: #212529;
  --topbar-menu-button-text-color: #ffc107;
  --topbar-item-text-color: #212529;
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: #ffc107;
}
.layout-topbar-orange {
  --topbar-bg: #fd7e14;
  --topbar-menu-button-bg: #212529;
  --topbar-menu-button-text-color: #fd7e14;
  --topbar-item-text-color: #ffffff;
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: #fd7e14;
}
.layout-topbar-indigo {
  --topbar-bg: #6610f2;
  --topbar-menu-button-bg: #ffffff;
  --topbar-menu-button-text-color: #6610f2;
  --topbar-item-text-color: #ffffff;
  --topbar-item-hover-bg: rgba(255, 255, 255, 0.16);
  --topbar-border-color: #6610f2;
}
.layout-topbar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 4rem;
  transition: width var(--transition-duration);
  display: flex;
  color: var(--topbar-item-text-color);
  background-color: var(--topbar-bg);
  border-bottom: 1px solid var(--topbar-border-color, --topbar-bg);
}
.layout-topbar ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.layout-topbar .layout-topbar-start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem;
  position: relative;
  flex: 1 1 33.333%;
  min-width: 0;
}
.layout-topbar .layout-topbar-start .company-title {
  flex-shrink: 0;
  margin-right: auto;
}
.layout-topbar .layout-topbar-start .layout-topbar-logo {
  display: flex;
  align-items: center;
  justify-content: start;
}
.layout-topbar .layout-topbar-start .layout-topbar-logo img {
  height: 2.5rem;
}
.layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-slim {
  display: none;
}
.layout-topbar .layout-topbar-start .layout-menu-button {
  position: absolute;
  top: 50%;
  margin-top: -1.25rem;
  right: -1.25rem;
  width: 2.5rem;
  height: 2.5rem;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius);
  color: var(--topbar-menu-button-text-color);
  background-color: var(--topbar-menu-button-bg);
  transition: background-color var(--transition-duration);
  cursor: pointer;
}
.layout-topbar .layout-topbar-start .layout-menu-button i {
  font-size: 2rem;
  transition: transform var(--transition-duration);
}
.layout-topbar .layout-topbar-end {
  display: flex;
  flex: 1 1 33.333%;
  align-items: center;
  justify-content: flex-end;
  padding: 0 1rem;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li {
  position: relative;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > a,
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li button {
  width: 2.5rem;
  height: 2.5rem;
  -webkit-user-select: none;
  user-select: none;
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--topbar-item-text-color);
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > a i,
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li button i {
  font-size: 1.25rem;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > a:hover,
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li button:hover {
  background-color: var(--topbar-item-hover-bg);
  transition: background-color var(--transition-duration);
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > div {
  position: absolute;
  top: 3.5rem;
  right: 0;
  min-width: 18rem;
  padding: 0.5rem 0;
  transform-origin: top;
  background: var(--surface-overlay);
  color: var(--text-color);
  border-top: 4px solid var(--topbar-bg);
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search {
  position: relative;
  display: flex;
  align-items: center;
  width: auto;
  min-width: 14rem;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete {
  width: 100%;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-autocomplete-input {
  padding: 0.5rem 1rem;
  padding-right: 2.5rem;
  color: var(--topbar-item-text-color);
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid var(--topbar-item-text-color);
  border-radius: 1.5rem;
  width: 14rem;
  font-size: 1rem;
  transition: var(--transition-duration);
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-autocomplete-input::placeholder {
  color: var(--topbar-item-text-color);
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-autocomplete-input:focus {
  outline: 0 none;
  border: 1px solid var(--topbar-item-text-color);
  background-color: rgba(255, 255, 255, 0.3);
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-autocomplete-clear-icon,
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-button.p-autocomplete-clear {
  color: var(--topbar-item-text-color);
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1rem;
  cursor: pointer;
  z-index: 12;
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  min-height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  line-height: 1;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-autocomplete-clear-icon:hover,
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-button.p-autocomplete-clear:hover {
  opacity: 0.8;
  background: rgba(255, 255, 255, 0.1);
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-autocomplete-clear-icon:focus,
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-button.p-autocomplete-clear:focus {
  outline: none;
  box-shadow: none;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-autocomplete-clear-icon .p-icon,
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-autocomplete-clear-icon i,
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-button.p-autocomplete-clear .p-icon,
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .p-autocomplete .p-button.p-autocomplete-clear i {
  color: var(--topbar-item-text-color);
  font-size: 0.875rem;
  margin: 0;
  padding: 0;
  line-height: 1;
  position: relative;
  top: 0;
  left: 0;
  transform: none;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .search-icon {
  color: var(--topbar-item-text-color);
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1rem;
  cursor: pointer;
  z-index: 11;
  transition: all 0.3s ease;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .search-icon:hover {
  opacity: 0.8;
}
.layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search .search-icon.hidden {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
.layout-topbar .layout-topbar-center {
  display: flex;
  flex: 1 1 33.333%;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  min-width: 0;
  overflow: hidden;
}
.layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
}
.layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li {
  position: relative;
  align-content: center;
}
.layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li > a,
.layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li button {
  width: 2rem;
  height: 2rem;
  -webkit-user-select: none;
  user-select: none;
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--topbar-item-text-color);
}
.layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li > a i,
.layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li button i {
  font-size: 1.2em;
}
.layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li > a:hover,
.layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li button:hover {
  background-color: var(--topbar-item-hover-bg);
  transition: background-color var(--transition-duration);
}
.layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li > div {
  position: absolute;
  top: 3.5rem;
  right: 0;
  min-width: 18rem;
  padding: 0.5rem 0;
  transform-origin: top;
  background: var(--surface-overlay);
  color: var(--text-color);
  border-top: 4px solid var(--topbar-bg);
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
@media screen and (min-width: 1200px) {
  .layout-topbar .layout-topbar-start {
    flex: 1 1 40%;
  }
  .layout-topbar .layout-topbar-center {
    flex: 1 1 35%;
  }
  .layout-topbar .layout-topbar-end {
    flex: 1 1 25%;
  }
}
@keyframes clippath {
  0%, 100% {
    clip-path: inset(0 0 90% 0);
  }
  25% {
    clip-path: inset(0 90% 0 0);
  }
  50% {
    clip-path: inset(90% 0 0 0);
  }
  75% {
    clip-path: inset(0 0 0 90%);
  }
}
.layout-menu-light {
  --menu-bg: #ffffff;
  --root-menuitem-text-color: var(--p-text-color);
  --menuitem-text-color: var(--p-text-muted-color);
  --menuitem-hover-bg: rgba(0, 0, 0, 0.04);
  --active-menuitem-text-color: var(--p-primary-500);
  --active-menuitem-bg: var(--p-primary-50);
  --inline-menu-border-color: var(--p-content-border-color);
}
.layout-menu-dark {
  --menu-bg: var(--p-surface-950);
  --root-menuitem-text-color: rgba(255, 255, 255, 0.6);
  --menuitem-text-color: rgba(255, 255, 255, 0.87);
  --menuitem-hover-bg: hsla(0, 0%, 100%, 0.07);
  --active-menuitem-text-color: rgba(255, 255, 255, 0.87);
  --active-menuitem-bg: hsla(0, 0%, 100%, 0.04);
  --inline-menu-border-color: hsla(0, 0%, 100%, 0.12);
}
.layout-sidebar {
  position: fixed;
  height: calc(100% - 4rem);
  top: 4rem;
  left: 0;
  width: 17rem;
  background: var(--menu-bg);
  border-right: 1px solid var(--surface-border);
  display: flex;
  flex-direction: column;
}
.layout-sidebar .layout-sidebar-top {
  display: none;
}
.layout-sidebar .layout-menu-container {
  flex: 1;
  padding-bottom: 2rem;
  overflow: auto;
}
.layout-sidebar .layout-menu {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
  display: flex;
  align-items: center;
  font-size: 0.857rem;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--root-menuitem-text-color);
  padding: 1rem 1.5rem 1rem 1rem;
}
.layout-sidebar .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
  display: none;
}
.layout-sidebar .layout-menu .layout-root-menuitem > a {
  display: none;
}
.layout-sidebar .layout-menu a {
  -webkit-user-select: none;
  user-select: none;
}
.layout-sidebar .layout-menu li.active-menuitem > a {
  color: var(--active-menuitem-text-color);
  background-color: var(--active-menuitem-bg);
}
.layout-sidebar .layout-menu li.active-menuitem > a .layout-menuitem-icon {
  margin-right: 0.5rem;
  color: var(--active-menuitem-text-color);
}
.layout-sidebar .layout-menu li.active-menuitem > a .layout-submenu-toggler {
  transform: rotate(-180deg);
}
.layout-sidebar .layout-menu ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.layout-sidebar .layout-menu ul a {
  display: flex;
  align-items: center;
  position: relative;
  outline: 0 none;
  color: var(--menuitem-text-color);
  cursor: pointer;
  padding: 0.75rem 1.5rem;
  transition: background-color var(--transition-duration), box-shadow var(--transition-duration);
}
.layout-sidebar .layout-menu ul a .layout-menuitem-icon {
  margin-right: 0.5rem;
  color: var(--menuitem-text-color);
}
.layout-sidebar .layout-menu ul a .layout-submenu-toggler {
  font-size: 75%;
  margin-left: auto;
  transition: transform var(--transition-duration);
}
.layout-sidebar .layout-menu ul a.active-route {
  font-weight: 700;
}
.layout-sidebar .layout-menu ul a:hover {
  background-color: var(--menuitem-hover-bg);
}
.layout-sidebar .layout-menu ul ul {
  overflow: hidden;
  border-radius: var(--border-radius);
}
.layout-sidebar .layout-menu ul ul li a {
  padding-left: 2.5rem;
}
.layout-sidebar .layout-menu ul ul li li a {
  padding-left: 3rem;
}
.layout-sidebar .layout-menu ul ul li li li a {
  padding-left: 3.5rem;
}
.layout-sidebar .layout-menu ul ul li li li li a {
  padding-left: 4rem;
}
.layout-sidebar .layout-menu ul ul li li li li li a {
  padding-left: 5.5rem;
}
.layout-sidebar .layout-menu ul ul li li li li li li a {
  padding-left: 5rem;
}
@media screen and (min-width: 992px) {
  .layout-container.layout-slim .layout-sidebar {
    width: 5rem;
    overflow: visible;
    z-index: 998;
  }
  .layout-container.layout-slim .layout-sidebar .layout-menu-container {
    overflow: auto;
  }
  .layout-container.layout-slim .layout-sidebar .layout-menu-container::-webkit-scrollbar {
    display: none;
  }
  .layout-container.layout-slim .layout-topbar .layout-topbar-start {
    width: 5rem;
  }
  .layout-container.layout-slim .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-full {
    display: none;
  }
  .layout-container.layout-slim .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-slim {
    display: block;
  }
  .layout-container.layout-slim .layout-topbar .layout-topbar-start .layout-menu-button {
    display: none;
  }
  .layout-container.layout-slim .layout-content-wrapper {
    margin-left: 5rem;
  }
  .layout-container.layout-slim .layout-menu {
    padding: 1rem 0;
  }
  .layout-container.layout-slim .layout-menu ul {
    display: none;
  }
  .layout-container.layout-slim .layout-menu li.active-menuitem > ul {
    display: block;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem {
    margin: 0.75rem 0;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem:first-child {
    margin-top: 0;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem:last-child {
    margin-top: 0;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    display: none;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > a {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    outline: none;
    transition: background-color var(--layout-section-transition-duration);
    width: 3rem;
    height: 3rem;
    margin: 0 auto;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > a .layout-submenu-toggler {
    display: none;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > a .layout-menuitem-icon {
    font-size: 1.5rem;
    color: var(--menuitem-text-color);
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > a .layout-menuitem-text {
    display: none;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > a:hover {
    background-color: var(--menuitem-hover-bg);
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul {
    position: absolute;
    left: 5rem;
    top: 0;
    min-width: 15rem;
    background-color: var(--menu-bg);
    border-radius: var(--border-radius);
    padding: 0.5rem 0;
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
    box-shadow:
      0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 8px 10px 1px rgba(0, 0, 0, 0.14),
      0 3px 14px 2px rgba(0, 0, 0, 0.12);
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul::-webkit-scrollbar {
    display: none;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul a {
    padding-right: 0.5rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li a {
    padding-left: 0.5rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li a {
    padding-left: 1rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li a {
    padding-left: 1.5rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li li a {
    padding-left: 2rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li li li a {
    padding-left: 2.5rem;
  }
  .layout-container.layout-slim .layout-menu .layout-root-menuitem > ul li li li li li li a {
    padding-left: 3rem;
  }
  .layout-container.layout-slim .layout-menu-profile {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .layout-container.layout-slim .layout-menu-profile > button {
    width: 3rem;
    height: 3rem;
    padding: 0;
    border-radius: 50%;
    justify-content: center;
    margin: 0.75rem 0;
  }
  .layout-container.layout-slim .layout-menu-profile > button span,
  .layout-container.layout-slim .layout-menu-profile > button i {
    display: none;
  }
  .layout-container.layout-slim .layout-menu-profile > ul > li {
    margin: 0.75rem 0;
  }
  .layout-container.layout-slim .layout-menu-profile > ul > li:first-child {
    margin-top: 0;
  }
  .layout-container.layout-slim .layout-menu-profile > ul > li > button {
    width: 3rem;
    height: 3rem;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
  .layout-container.layout-slim .layout-menu-profile > ul > li > button > i {
    font-size: 1.5rem;
    margin-right: 0;
  }
  .layout-container.layout-slim .layout-menu-profile > ul > li > button > span {
    display: none;
  }
  .layout-container.layout-slim .layout-menu-profile > ul > li:last-child {
    margin-bottom: 1rem;
  }
}
@media screen and (min-width: 992px) {
  .layout-container.layout-slim-plus .layout-sidebar {
    width: 7rem;
    overflow: visible;
    z-index: 998;
  }
  .layout-container.layout-slim-plus .layout-sidebar .layout-menu-container {
    overflow: auto;
  }
  .layout-container.layout-slim-plus .layout-sidebar .layout-menu-container::-webkit-scrollbar {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start {
    width: 7rem;
  }
  .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-full {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start .layout-topbar-logo .layout-topbar-logo-slim {
    display: block;
  }
  .layout-container.layout-slim-plus .layout-topbar .layout-topbar-start .layout-menu-button {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-content-wrapper {
    margin-left: 7rem;
  }
  .layout-container.layout-slim-plus .layout-menu {
    padding: 1rem 0;
  }
  .layout-container.layout-slim-plus .layout-menu ul {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-menu li.active-menuitem > ul {
    display: block;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem {
    margin: 0.75rem 0;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem:first-child {
    margin-top: 0;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem:last-child {
    margin-top: 0;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: var(--border-radius);
    cursor: pointer;
    outline: none;
    transition: background-color var(--layout-section-transition-duration);
    width: auto;
    height: auto;
    margin: 0 auto 1rem auto;
    padding: 0.75rem 0;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a .layout-submenu-toggler {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a .layout-menuitem-icon {
    font-size: 1.5rem;
    color: var(--menuitem-text-color);
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a .layout-menuitem-text {
    font-size: 0.875rem;
    display: block;
    margin-top: 0.25rem;
    color: var(--menuitem-text-color);
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > a:hover {
    background-color: var(--menuitem-hover-bg);
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul {
    position: absolute;
    left: 7rem;
    top: 0;
    min-width: 15rem;
    background-color: var(--menu-bg);
    border-radius: var(--border-radius);
    padding: 0.5rem 0;
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
    box-shadow:
      0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 8px 10px 1px rgba(0, 0, 0, 0.14),
      0 3px 14px 2px rgba(0, 0, 0, 0.12);
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul::-webkit-scrollbar {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul a {
    padding-right: 0.5rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li a {
    padding-left: 0.5rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li a {
    padding-left: 1rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li a {
    padding-left: 1.5rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li li a {
    padding-left: 2rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li li li a {
    padding-left: 2.5rem;
  }
  .layout-container.layout-slim-plus .layout-menu .layout-root-menuitem > ul li li li li li li a {
    padding-left: 3rem;
  }
  .layout-container.layout-slim-plus .layout-menu-profile {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .layout-container.layout-slim-plus .layout-menu-profile > button {
    width: 3rem;
    height: 3rem;
    padding: 0;
    border-radius: 50%;
    justify-content: center;
    margin: 0.75rem 0;
  }
  .layout-container.layout-slim-plus .layout-menu-profile > button span,
  .layout-container.layout-slim-plus .layout-menu-profile > button i {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-menu-profile > ul > li {
    margin: 0.75rem 0;
  }
  .layout-container.layout-slim-plus .layout-menu-profile > ul > li:first-child {
    margin-top: 0;
  }
  .layout-container.layout-slim-plus .layout-menu-profile > ul > li > button {
    width: 3rem;
    height: 3rem;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
  .layout-container.layout-slim-plus .layout-menu-profile > ul > li > button > i {
    font-size: 1.5rem;
    margin-right: 0;
  }
  .layout-container.layout-slim-plus .layout-menu-profile > ul > li > button > span {
    display: none;
  }
  .layout-container.layout-slim-plus .layout-menu-profile > ul > li:last-child {
    margin-bottom: 1rem;
  }
}
@media screen and (min-width: 992px) {
  .layout-container.layout-horizontal .layout-sidebar {
    width: 100%;
    height: 4rem;
    top: 4rem;
    position: fixed;
    z-index: 998;
    overflow: visible;
    flex-direction: row;
    padding: 0 2rem;
  }
  .layout-container.layout-horizontal .layout-sidebar .layout-menu-container {
    overflow: auto;
    padding-bottom: 0;
  }
  .layout-container.layout-horizontal .layout-sidebar .layout-menu-container::-webkit-scrollbar {
    display: none;
  }
  .layout-container.layout-horizontal .layout-sidebar .layout-menu-container div[app-menu] {
    height: 100%;
  }
  .layout-container.layout-horizontal .layout-topbar .layout-topbar-start .layout-menu-button {
    display: none;
  }
  .layout-container.layout-horizontal .layout-content-wrapper {
    padding-top: 8rem;
  }
  .layout-container.layout-horizontal .layout-menu {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    height: 100%;
  }
  .layout-container.layout-horizontal .layout-menu ul {
    display: none;
  }
  .layout-container.layout-horizontal .layout-menu li.active-menuitem > ul {
    display: block;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem {
    border-radius: var(--border-radius);
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    display: none;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a {
    display: flex;
    align-items: center;
    padding: 0.75rem;
    border-radius: 0;
    cursor: pointer;
    outline: none;
    color: var(--menuitem-text-color);
    transition: background-color var(--transition-duration);
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a .layout-submenu-toggler {
    display: block;
    margin-left: auto;
    transition: transform 0.2s;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a .layout-menuitem-icon {
    font-size: 1.25rem;
    color: var(--menuitem-text-color);
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a .layout-menuitem-text {
    font-size: 0.875rem;
    display: block;
    margin-left: 0.75rem;
    margin-right: 0.75rem;
    white-space: nowrap;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > a:hover {
    background-color: var(--menuitem-hover-bg);
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul {
    position: absolute;
    left: auto;
    top: 3rem;
    min-width: 15rem;
    background-color: var(--menu-bg);
    box-shadow:
      0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 8px 10px 1px rgba(0, 0, 0, 0.14),
      0 3px 14px 2px rgba(0, 0, 0, 0.12);
    padding: 0.5rem 0;
    border-radius: var(--border-radius);
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul::-webkit-scrollbar {
    display: none;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul a {
    padding-right: 0.5rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li a {
    padding-left: 0.5rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li a {
    padding-left: 1rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li a {
    padding-left: 1.5rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li li a {
    padding-left: 2rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li li li a {
    padding-left: 2.5rem;
  }
  .layout-container.layout-horizontal .layout-menu .layout-root-menuitem > ul li li li li li li a {
    padding-left: 3rem;
  }
  .layout-container.layout-horizontal.layout-menu-profile-start .layout-menu-profile {
    border-bottom: 0 none;
  }
  .layout-container.layout-horizontal.layout-menu-profile-start .layout-menu-profile > ul {
    left: 0;
  }
  .layout-container.layout-horizontal.layout-menu-profile-end .layout-menu-profile {
    border-bottom: 0 none;
  }
  .layout-container.layout-horizontal.layout-menu-profile-end .layout-menu-profile > ul {
    right: 0;
  }
  .layout-container.layout-horizontal .layout-menu-profile {
    position: relative;
    overflow: visible;
    width: auto;
    height: 100%;
  }
  .layout-container.layout-horizontal .layout-menu-profile > button {
    padding: 0 0.75rem;
    width: auto;
    height: 100%;
  }
  .layout-container.layout-horizontal .layout-menu-profile > button .layout-menu-profile-toggler {
    margin-left: 0.5rem;
  }
  .layout-container.layout-horizontal .layout-menu-profile > ul {
    position: absolute;
    top: 3rem;
    min-width: 15rem;
    background-color: var(--menu-bg);
    box-shadow:
      0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 8px 10px 1px rgba(0, 0, 0, 0.14),
      0 3px 14px 2px rgba(0, 0, 0, 0.12);
    padding: 1rem;
    border-radius: var(--border-radius);
    max-height: 20rem;
    overflow: auto;
    z-index: 999;
    transform-origin: center top;
  }
  .layout-container.layout-horizontal .layout-menu-profile > ul > li > button {
    padding: 0.75rem 0.5rem;
  }
}
@media screen and (min-width: 992px) {
  .layout-reveal .layout-sidebar {
    height: 100%;
    top: 0;
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
    transform: translateX(-12.75rem);
    z-index: 999;
  }
  .layout-reveal .layout-sidebar .layout-sidebar-top {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 0.75rem;
    height: 4rem;
    background-color: var(--topbar-bg);
    color: var(--topbar-item-text-color);
  }
  .layout-reveal .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {
    display: none;
  }
  .layout-reveal .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {
    display: inline;
  }
  .layout-reveal .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {
    display: none;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    border: 2px solid var(--topbar-menu-button-bg);
    background-color: transparent;
    transition: background-color var(--layout-section-transition-duration), transform 0.3s;
  }
  .layout-reveal .layout-sidebar .layout-menu-container {
    overflow: hidden;
  }
  .layout-reveal .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > span {
    margin-right: auto;
  }
  .layout-reveal .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: block;
    margin-right: 0.125rem;
  }
  .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul a .layout-menuitem-text {
    order: 1;
    margin-right: auto;
  }
  .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {
    order: 2;
    display: none;
    margin-right: 0.5rem;
  }
  .layout-reveal .layout-sidebar .layout-menu-container .layout-menu ul a .layout-menuitem-icon {
    order: 3;
    margin-right: 0;
    font-size: 1.25rem;
    width: auto;
  }
  .layout-reveal .layout-sidebar .layout-menu-profile > ul > li > button {
    flex-direction: row-reverse;
  }
  .layout-reveal .layout-sidebar .layout-menu-profile > ul > li > button > i {
    margin-right: 0;
    margin-left: auto;
    font-size: 1.25rem;
    width: auto;
  }
  .layout-reveal .layout-topbar {
    padding-left: 4.25rem;
  }
  .layout-reveal .layout-topbar .layout-topbar-start {
    display: none;
  }
  .layout-reveal.layout-reveal .layout-content-wrapper {
    margin-left: 4.25rem;
    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  .layout-reveal.layout-sidebar-active .layout-sidebar {
    transform: translateX(0);
  }
  .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top {
    padding: 0 1.5rem;
    justify-content: space-between;
  }
  .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {
    display: inline;
  }
  .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {
    display: none;
  }
  .layout-reveal.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {
    display: block;
    animation: px-fadein 0.15s linear;
  }
  .layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu-container {
    overflow: auto;
  }
  .layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: none;
  }
  .layout-reveal.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {
    display: block;
  }
  .layout-reveal.layout-sidebar-anchored .layout-topbar {
    padding-left: 17rem;
  }
  .layout-reveal.layout-sidebar-anchored .layout-sidebar-top .layout-sidebar-anchor {
    background-color: var(--topbar-menu-button-bg);
  }
  .layout-reveal.layout-sidebar-anchored .layout-content-wrapper {
    margin-left: 17rem;
  }
}
@media screen and (min-width: 992px) {
  .layout-drawer .layout-sidebar {
    height: 100%;
    top: 0;
    transition: width 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: 4.25rem;
    z-index: 999;
  }
  .layout-drawer .layout-sidebar .layout-sidebar-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.75rem;
    height: 4rem;
    background-color: var(--topbar-bg);
    color: var(--topbar-item-text-color);
  }
  .layout-drawer .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {
    display: none;
    width: 0;
    transition: width 0.2s cubic-bezier(0, 0, 0.2, 1);
    transition-delay: 300ms;
  }
  .layout-drawer .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {
    display: inline;
    order: 1;
  }
  .layout-drawer .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {
    display: none;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    border: 2px solid var(--topbar-menu-button-bg);
    background-color: transparent;
    transition: background-color var(--layout-sectiontransition-duration), transform 0.3s;
  }
  .layout-drawer .layout-sidebar .layout-menu-container {
    overflow: hidden;
  }
  .layout-drawer .layout-sidebar .layout-menu-container .layout-menu {
    transition: all 0.4s;
  }
  .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    opacity: 1;
    white-space: nowrap;
    display: flex;
    justify-content: flex-end;
    height: 2.92rem;
  }
  .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > span {
    margin-right: auto;
    opacity: 0;
    transition: all 0.1s;
  }
  .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text .layout-menuitem-icon {
    font-size: 1.25rem;
    width: 1.25rem;
  }
  .layout-drawer .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: block;
    margin-left: 0.125rem;
    font-size: 1.25rem;
  }
  .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul a span {
    opacity: 0;
    white-space: nowrap;
    transition: all 0.1s;
  }
  .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul a .layout-menuitem-icon {
    font-size: 1.25rem;
    width: auto;
  }
  .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {
    display: none;
  }
  .layout-drawer .layout-sidebar .layout-menu-container .layout-menu ul ul li a {
    padding: 0.75rem 1.5rem;
  }
  .layout-drawer .layout-sidebar .layout-menu-profile > button {
    padding: 0.75rem 1rem;
  }
  .layout-drawer .layout-sidebar .layout-menu-profile > button span {
    opacity: 0;
    white-space: nowrap;
    transition: all 0.1s;
  }
  .layout-drawer .layout-sidebar .layout-menu-profile > ul > li > button > i {
    margin-right: 0.5rem;
    font-size: 1.25rem;
    width: auto;
  }
  .layout-drawer .layout-topbar {
    padding-left: 4.25rem;
  }
  .layout-drawer .layout-topbar .layout-topbar-start {
    display: none;
  }
  .layout-drawer.layout-drawer .layout-content-wrapper {
    margin-left: 4.25rem;
    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);
    overflow-x: hidden;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar {
    width: 17rem;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top {
    padding: 0 1.5rem;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo {
    display: inline;
    width: 100%;
    transition: width 0.2s cubic-bezier(0, 0, 0.2, 1);
    transition-delay: 300ms;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-logo-slim {
    display: none;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-sidebar-top .layout-sidebar-anchor {
    display: block;
    animation: px-fadein 0.15s linear;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container {
    overflow: auto;
    overflow-x: hidden;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text {
    white-space: nowrap;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > .layout-menuitem-root-icon {
    display: none;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu .layout-root-menuitem > .layout-menuitem-root-text > span {
    margin-right: auto;
    opacity: 1;
    transition: all 0.1s;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a {
    width: auto;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a .layout-submenu-toggler {
    display: block;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul a span {
    opacity: 1;
    white-space: nowrap;
    transition: all 0.3s;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul {
    overflow: hidden;
    border-radius: var(--border-radius);
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li a {
    padding-left: 2.5rem;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li a {
    padding-left: 3rem;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li a {
    padding-left: 3.5rem;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li li a {
    padding-left: 4rem;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li li li a {
    padding-left: 5.5rem;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-container .layout-menu ul ul li li li li li li a {
    padding-left: 5rem;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-profile > button span {
    opacity: 1;
    white-space: nowrap;
    transition: all 0.1s;
  }
  .layout-drawer.layout-sidebar-active .layout-sidebar .layout-menu-profile > ul > li > button > i {
    margin-right: 0.5rem;
    font-size: 1.25rem;
    width: auto;
  }
  .layout-drawer.layout-sidebar-anchored .layout-topbar {
    padding-left: 17rem;
  }
  .layout-drawer.layout-sidebar-anchored .layout-sidebar-top .layout-sidebar-anchor {
    background-color: var(--topbar-menu-button-bg);
  }
  .layout-drawer.layout-sidebar-anchored .layout-content-wrapper {
    margin-left: 17rem;
  }
}
.layout-container.layout-menu-profile-active .layout-menu-profile-toggler {
  transform: rotate(-180deg);
}
.layout-container.layout-menu-profile-end .layout-menu-profile {
  border-top: 1px solid var(--inline-menu-border-color);
}
.layout-container.layout-menu-profile-start .layout-menu-profile {
  border-bottom: 1px solid var(--inline-menu-border-color);
}
.layout-sidebar .layout-menu-profile {
  width: 100%;
  background: var(--menu-bg);
  overflow: hidden;
  border-bottom: 1px solid var(--surface-border);
}
.layout-sidebar .layout-menu-profile > button {
  text-align: left;
  background-color: transparent;
  margin: 0;
  border: 0;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0.5rem 1.5rem;
  color: var(--menuitem-text-color);
  transition: background-color var(--layout-section-transition-duration);
}
.layout-sidebar .layout-menu-profile > button > span {
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
}
.layout-sidebar .layout-menu-profile > button > i {
  margin-left: auto;
  transition: transform var(--layout-section-transition-duration);
}
.layout-sidebar .layout-menu-profile > button:hover {
  background-color: var(--menuitem-hover-bg);
}
.layout-sidebar .layout-menu-profile > ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.layout-sidebar .layout-menu-profile > ul > li > button {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  transition: background-color var(--layout-section-transition-duration), box-shadow var(--layout-section-transition-duration);
  color: var(--menuitem-text-color);
}
.layout-sidebar .layout-menu-profile > ul > li > button > i {
  margin-right: 0.5rem;
  color: var(--menuitem-text-color);
}
.layout-sidebar .layout-menu-profile > ul > li > button:hover {
  background-color: var(--menuitem-hover-bg);
}
.parallax__layer__0 {
  transform: translateZ(-150px) scale(2.5);
}
.parallax__layer__1 {
  transform: translateZ(-100px) scale(2);
}
.parallax__layer__2 {
  transform: translateZ(-50px) scale(1.5);
}
.parallax__layer__3 {
  transform: translateZ(0px) scale(1);
}
html {
  height: 100%;
  font-size: 14px;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Helvetica,
    Arial,
    sans-serif,
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-feature-settings:
    "cv02",
    "cv03",
    "cv04",
    "cv11";
}
body {
  font-weight: 400;
  padding: 0;
  margin: 0;
  min-height: 100%;
  background: var(--surface-ground);
  color: var(--text-color);
  line-height: 1.4;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
a {
  text-decoration: none;
}
.p-toast.p-toast-top-right,
.p-toast.p-toast-top-left,
.p-toast.p-toast-top-center {
  top: 85px;
}
.layout-content-wrapper {
  padding-top: 4rem;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.layout-content-wrapper .layout-content {
  flex: 1 1 auto;
  padding: 0.25rem;
}
.layout-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  background-color: var(--surface-card);
}
.layout-breadcrumb-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--surface-border);
  padding: 0.5rem 2rem;
  background-color: var(--surface-card);
}
.layout-breadcrumb-container .layout-breadcrumb ol {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  gap: 0.5rem;
  flex-wrap: wrap;
  color: var(--text-color-secondary);
}
.layout-breadcrumb-container .layout-breadcrumb ol li {
  display: flex;
  align-items: center;
}
.layout-breadcrumb-container .layout-breadcrumb-buttons {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.layout-breadcrumb-container .layout-breadcrumb-buttons button {
  flex-shrink: 0;
}
@media screen and (min-width: 992px) {
  .layout-container.layout-static .layout-sidebar {
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  .layout-container.layout-static .layout-content-wrapper {
    margin-left: 17rem;
    transition: margin-left 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  .layout-container.layout-static .layout-topbar .layout-menu-button i {
    transform: rotate(180deg);
  }
  .layout-container.layout-static-inactive .layout-sidebar {
    transform: translateX(-100%);
  }
  .layout-container.layout-static-inactive .layout-content-wrapper {
    margin-left: 0;
  }
  .layout-container.layout-static-inactive .layout-topbar .layout-menu-button i {
    transform: rotate(0deg);
  }
  .layout-container.layout-overlay .layout-content-wrapper {
    margin-left: 0;
  }
  .layout-container.layout-overlay .layout-sidebar {
    z-index: 999;
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  .layout-container.layout-overlay.layout-overlay-active .layout-sidebar {
    transform: translateX(0);
  }
  .layout-container.layout-overlay.layout-overlay-active .layout-topbar .layout-menu-button i {
    transform: rotate(180deg);
  }
  .layout-topbar .layout-topbar-start,
  .layout-topbar .layout-topbar-center,
  .layout-topbar .layout-topbar-end {
    flex: 1 1 33.333% !important;
  }
}
@media screen and (max-width: 991px) {
  .blocked-scroll {
    overflow: hidden;
  }
  .layout-container .layout-content-wrapper {
    margin-left: 0;
  }
  .layout-container .layout-sidebar {
    z-index: 999;
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  .layout-container.layout-mobile-active .layout-sidebar {
    transform: translateX(0);
  }
  .layout-container.layout-mobile-active .layout-mask {
    display: block;
    animation: px-mask-in 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
  .layout-container.layout-mobile-active .layout-topbar .layout-menu-button i {
    transform: rotate(180deg);
  }
  .layout-container .layout-mask {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    height: 100%;
    background-color: var(--maskbg);
  }
  .layout-topbar {
    display: flex;
  }
  .layout-topbar .layout-topbar-start {
    padding: 0 0.5rem;
    height: 4rem;
    justify-content: start;
    flex: 1 1 auto;
    flex-shrink: 1;
  }
  .layout-topbar .layout-topbar-start .layout-menu-button {
    position: relative;
    margin-top: 0;
    margin-left: 0.5rem;
    top: auto;
  }
  .layout-topbar .layout-topbar-start .layout-topbar-logo-slim .logo-img {
    width: 30px !important;
    height: 30px !important;
  }
  .layout-topbar .layout-topbar-center {
    padding: 0 0.5rem;
    flex: 1 1 auto;
    flex-shrink: 1;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items {
    gap: 0.125rem;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li > a,
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li button {
    width: 2rem !important;
    height: 2rem !important;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li > a i,
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li button i {
    font-size: 1rem !important;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li h2 {
    font-size: 0.875rem;
    margin: 0;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li h2 label {
    margin-right: 0.25rem;
  }
  .layout-topbar .layout-topbar-end {
    padding: 0 0.5rem 0 0;
    flex: 1 1 auto;
    flex-shrink: 0;
  }
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items {
    gap: 0.25rem;
  }
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > a,
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li button {
    width: 2rem !important;
    height: 2rem !important;
  }
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > a i,
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li button i {
    font-size: 1rem !important;
  }
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search input {
    width: 8rem !important;
    padding: 0.25rem 0.5rem !important;
    padding-right: 2rem !important;
    font-size: 0.75rem !important;
  }
}
@media screen and (min-width: 1729px) {
  .layout-content {
    width: 99%;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
@media screen and (max-width: 768px) {
  .layout-topbar .layout-topbar-start {
    padding: 0 0.25rem;
  }
  .layout-topbar .layout-topbar-start .layout-topbar-logo-slim .logo-img {
    width: 25px !important;
    height: 25px !important;
  }
  .layout-topbar .layout-topbar-start .layout-topbar-logo-slim .logo-home i {
    font-size: 1.25rem !important;
  }
  .layout-topbar .layout-topbar-center {
    padding: 0 0.25rem;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items {
    gap: 0.075rem;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li h2 {
    font-size: 0.75rem;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li h2 label {
    margin-right: 0.125rem;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li > a,
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li button {
    width: 1.75rem !important;
    height: 1.75rem !important;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li > a i,
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li button i {
    font-size: 0.875rem !important;
  }
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items {
    gap: 0.125rem;
  }
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > a,
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li button {
    width: 1.75rem !important;
    height: 1.75rem !important;
  }
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li > a i,
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li button i {
    font-size: 0.875rem !important;
  }
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search input {
    width: 6rem !important;
    padding: 0.125rem 0.25rem !important;
    padding-right: 1.75rem !important;
    font-size: 0.625rem !important;
  }
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search > i {
    right: 0.5rem !important;
    font-size: 1rem !important;
  }
}
@media screen and (max-width: 480px) {
  .layout-topbar .layout-topbar-start .company-title {
    display: none;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li h2 {
    font-size: 0.625rem;
  }
  .layout-topbar .layout-topbar-center .layout-topbar-actions-center .layout-topbar-items > li h2 label {
    max-width: 8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  .layout-topbar .layout-topbar-end .layout-topbar-actions-end .layout-topbar-items > li.layout-topbar-search {
    display: none;
  }
}
p-radio-button,
p-radiobutton,
p-radioButton {
  display: inline-flex;
}
p-tree .p-tree-node-checkbox {
  display: block;
}
p-treetable .p-treetable-node-checkbox {
  display: block;
}
.p-tag-icon {
  line-height: 1.2;
}
.p-tabs {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.p-tabs > .p-tablist {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0 0 0.25rem;
  max-width: 100%;
  box-sizing: border-box;
}
.p-tabs .p-tablist-content {
  overflow-x: auto;
  overflow-y: visible;
}
.p-tabs .p-tablist-tab-list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 0.375rem;
  padding: 0.4rem;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background-color: var(--p-ripple-background);
  border: 1px solid var(--p-surface-200, #e2e8f0);
  border-radius: 12px;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06);
}
.p-tabs .p-tab {
  --tab-cut-size: 10px;
  flex: 1 1 0;
  min-width: 0;
  justify-content: center;
  border: 1px solid transparent !important;
  background: transparent !important;
  border-radius: 6px !important;
  clip-path: polygon(0 0, calc(100% - var(--tab-cut-size)) 0, 100% var(--tab-cut-size), 100% 100%, 0 100%);
  padding: 0.65rem 1.1rem !important;
  margin: 0 !important;
  white-space: nowrap;
  font-size: 0.9375rem;
  font-weight: 500;
  color: var(--p-text-muted-color, #64748b);
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.12s ease;
}
.p-tabs .p-tab:not(.p-tab-active):not(.p-disabled) {
  background: var(--p-surface-50, #f8fafc) !important;
}
.p-tabs .p-tab:not(.p-tab-active):not(.p-disabled):hover {
  background: var(--p-surface-50, #f8fafc) !important;
  box-shadow: 0 2px 8px rgba(13, 17, 27, 0.199);
  color: var(--p-text-color, #334155);
}
.p-tabs .p-tab:not(.p-tab-active):not(.p-disabled):active {
  transform: scale(0.98);
}
.p-tabs .p-tab-active {
  background: var(--p-primary-50, #f0f9ff) !important;
  color: var(--p-primary-800, #075985) !important;
  font-weight: 600;
  border: 2px solid var(--p-primary-200, #bae6fd) !important;
  clip-path: none;
  box-shadow: 0 2px 8px rgba(2, 132, 199, 0.16), 0 1px 2px rgba(2, 132, 199, 0.08);
}
.p-tabs .p-tablist-active-bar {
  display: none !important;
}
.p-tabs > .p-tabpanels {
  margin-top: 0.85rem;
  padding: 1rem 1.15rem 1.15rem;
  background: var(--p-content-background, #ffffff);
  border: 1px solid var(--p-content-border-color, #e2e8f0);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}
html.app-dark .p-tabs .p-tablist-tab-list,
body.dark-theme .p-tabs .p-tablist-tab-list {
  background: var(--p-surface-800, #1e293b);
  border-color: var(--p-surface-600, #334155);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25);
}
html.app-dark .p-tabs .p-tab:not(.p-tab-active):not(.p-disabled),
body.dark-theme .p-tabs .p-tab:not(.p-tab-active):not(.p-disabled) {
  background: var(--p-surface-700, #334155) !important;
}
html.app-dark .p-tabs .p-tab:not(.p-tab-active):not(.p-disabled):hover,
body.dark-theme .p-tabs .p-tab:not(.p-tab-active):not(.p-disabled):hover {
  background: var(--p-surface-700, #334155) !important;
  box-shadow: 0 2px 8px rgba(128, 128, 128, 0.199);
  color: var(--p-text-color, #f1f5f9);
}
html.app-dark .p-tabs .p-tab-active,
body.dark-theme .p-tabs .p-tab-active {
  background: var(--p-primary-color-dark, rgba(9, 50, 73, 0.6901960784)) !important;
  color: var(--p-primary-100, #e0f2fe) !important;
  border: 1px solid var(--p-primary-700, #174158) !important;
  box-shadow: 0 2px 12px rgba(14, 165, 233, 0.28), 0 0 0 1px rgba(56, 189, 248, 0.28);
}
html.app-dark .p-tabs > .p-tabpanels,
body.dark-theme .p-tabs > .p-tabpanels {
  background: var(--p-content-background, #0f172a);
  border-color: var(--p-content-border-color, #334155);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}
.p-tabs.bulk-comment-tabs > .p-tablist {
  width: 100% !important;
  min-width: 100% !important;
  background: transparent !important;
  border: none !important;
}
.p-tabs.bulk-comment-tabs .p-tablist-content {
  width: 100% !important;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: var(--p-ripple-background) !important;
  border: 1px solid var(--p-surface-200, #e2e8f0) !important;
  border-radius: 12px !important;
}
.p-tabs.bulk-comment-tabs .p-tablist-tab-list {
  display: inline-flex !important;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  background-color: var(--p-ripple-background) !important;
  border: none !important;
}
.p-tabs.bulk-comment-tabs.bulk-comment-tabs-scroll .p-tablist-content {
  overflow-x: auto !important;
}
.p-tabs.bulk-comment-tabs.bulk-comment-tabs-scroll .p-tablist-tab-list {
  width: max-content !important;
  min-width: 100% !important;
  max-width: none !important;
}
.layout-config-button {
  display: block;
  position: fixed;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  background: var(--primary-color);
  color: var(--primary-color-text);
  text-align: center;
  top: 50%;
  right: 0;
  margin-top: -1.5rem;
  border-top-left-radius: var(--border-radius);
  border-bottom-left-radius: var(--border-radius);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition: background-color var(--transition-duration);
  overflow: hidden;
  cursor: pointer;
  z-index: 999;
  box-shadow: -0.25rem 0 1rem rgba(0, 0, 0, 0.15);
}
.layout-config-button.config-link {
  font-size: 1rem;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Helvetica,
    Arial,
    sans-serif,
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol";
  border: none;
}
.layout-config-button .config-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 1px var(--focus-ring--shadow);
}
.layout-config-button i {
  font-size: 2rem;
  line-height: inherit;
  transform: rotate(0deg);
  transition: transform 1s;
}
.layout-config-button:hover {
  background: var(--p-primary-400);
}
.app-config-button {
  position: relative;
  color: var(--topbar-item-text-color);
}
.app-config-button::before,
.app-config-button::after {
  content: "";
  position: absolute;
  inset: 0;
  border: 1px solid var(--topbar-item-text-color);
  transition: all 0.5s;
  animation: clippath 3s infinite linear;
  border-radius: 4px;
  opacity: 1;
}
.app-config-button::after {
  animation: clippath 3s infinite -1.5s linear;
}
@keyframes clippath {
  0% {
    clip-path: inset(0 0 98% 0);
  }
  12.5% {
    clip-path: inset(0 0 60% 0);
  }
  25% {
    clip-path: inset(0 98% 0 0);
  }
  37.5% {
    clip-path: inset(0 60% 0 0);
  }
  50% {
    clip-path: inset(98% 0 0 0);
  }
  62.5% {
    clip-path: inset(60% 0 0 0);
  }
  75% {
    clip-path: inset(0 0 0 98%);
  }
  87.5% {
    clip-path: inset(0 0 0 60%);
  }
  100% {
    clip-path: inset(0 0 98% 0);
  }
}
@font-face {
  font-family: "primeicons";
  font-display: block;
  src: url("./media/primeicons.eot");
  src:
    url("./media/primeicons.eot?#iefix") format("embedded-opentype"),
    url("./media/primeicons.woff2") format("woff2"),
    url("./media/primeicons.woff") format("woff"),
    url("./media/primeicons.ttf") format("truetype"),
    url("./media/primeicons.svg?#primeicons") format("svg");
  font-weight: normal;
  font-style: normal;
}
.pi {
  font-family: "primeicons";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.pi:before {
  --webkit-backface-visibility:hidden;
  backface-visibility: hidden;
}
.pi-fw {
  width: 1.28571429em;
  text-align: center;
}
.pi-spin {
  -webkit-animation: fa-spin 2s infinite linear;
  animation: fa-spin 2s infinite linear;
}
@media (prefers-reduced-motion: reduce) {
  .pi-spin {
    -webkit-animation-delay: -1ms;
    animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
    animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
    transition-delay: 0s;
    -webkit-transition-duration: 0s;
    transition-duration: 0s;
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.pi-folder-plus:before {
  content: "\ea05";
}
.pi-receipt:before {
  content: "\ea06";
}
.pi-asterisk:before {
  content: "\ea07";
}
.pi-face-smile:before {
  content: "\ea08";
}
.pi-pinterest:before {
  content: "\ea09";
}
.pi-expand:before {
  content: "\ea0a";
}
.pi-pen-to-square:before {
  content: "\ea0b";
}
.pi-wave-pulse:before {
  content: "\ea0c";
}
.pi-turkish-lira:before {
  content: "\ea0d";
}
.pi-spinner-dotted:before {
  content: "\ea0e";
}
.pi-crown:before {
  content: "\ea0f";
}
.pi-pause-circle:before {
  content: "\ea10";
}
.pi-warehouse:before {
  content: "\ea11";
}
.pi-objects-column:before {
  content: "\ea12";
}
.pi-clipboard:before {
  content: "\ea13";
}
.pi-play-circle:before {
  content: "\ea14";
}
.pi-venus:before {
  content: "\ea15";
}
.pi-cart-minus:before {
  content: "\ea16";
}
.pi-file-plus:before {
  content: "\ea17";
}
.pi-microchip:before {
  content: "\ea18";
}
.pi-twitch:before {
  content: "\ea19";
}
.pi-building-columns:before {
  content: "\ea1a";
}
.pi-file-check:before {
  content: "\ea1b";
}
.pi-microchip-ai:before {
  content: "\ea1c";
}
.pi-trophy:before {
  content: "\ea1d";
}
.pi-barcode:before {
  content: "\ea1e";
}
.pi-file-arrow-up:before {
  content: "\ea1f";
}
.pi-mars:before {
  content: "\ea20";
}
.pi-tiktok:before {
  content: "\ea21";
}
.pi-arrow-up-right-and-arrow-down-left-from-center:before {
  content: "\ea22";
}
.pi-ethereum:before {
  content: "\ea23";
}
.pi-list-check:before {
  content: "\ea24";
}
.pi-thumbtack:before {
  content: "\ea25";
}
.pi-arrow-down-left-and-arrow-up-right-to-center:before {
  content: "\ea26";
}
.pi-equals:before {
  content: "\ea27";
}
.pi-lightbulb:before {
  content: "\ea28";
}
.pi-star-half:before {
  content: "\ea29";
}
.pi-address-book:before {
  content: "\ea2a";
}
.pi-chart-scatter:before {
  content: "\ea2b";
}
.pi-indian-rupee:before {
  content: "\ea2c";
}
.pi-star-half-fill:before {
  content: "\ea2d";
}
.pi-cart-arrow-down:before {
  content: "\ea2e";
}
.pi-calendar-clock:before {
  content: "\ea2f";
}
.pi-sort-up-fill:before {
  content: "\ea30";
}
.pi-sparkles:before {
  content: "\ea31";
}
.pi-bullseye:before {
  content: "\ea32";
}
.pi-sort-down-fill:before {
  content: "\ea33";
}
.pi-graduation-cap:before {
  content: "\ea34";
}
.pi-hammer:before {
  content: "\ea35";
}
.pi-bell-slash:before {
  content: "\ea36";
}
.pi-gauge:before {
  content: "\ea37";
}
.pi-shop:before {
  content: "\ea38";
}
.pi-headphones:before {
  content: "\ea39";
}
.pi-eraser:before {
  content: "\ea04";
}
.pi-stopwatch:before {
  content: "\ea01";
}
.pi-verified:before {
  content: "\ea02";
}
.pi-delete-left:before {
  content: "\ea03";
}
.pi-hourglass:before {
  content: "\e9fe";
}
.pi-truck:before {
  content: "\ea00";
}
.pi-wrench:before {
  content: "\e9ff";
}
.pi-microphone:before {
  content: "\e9fa";
}
.pi-megaphone:before {
  content: "\e9fb";
}
.pi-arrow-right-arrow-left:before {
  content: "\e9fc";
}
.pi-bitcoin:before {
  content: "\e9fd";
}
.pi-file-edit:before {
  content: "\e9f6";
}
.pi-language:before {
  content: "\e9f7";
}
.pi-file-export:before {
  content: "\e9f8";
}
.pi-file-import:before {
  content: "\e9f9";
}
.pi-file-word:before {
  content: "\e9f1";
}
.pi-gift:before {
  content: "\e9f2";
}
.pi-cart-plus:before {
  content: "\e9f3";
}
.pi-thumbs-down-fill:before {
  content: "\e9f4";
}
.pi-thumbs-up-fill:before {
  content: "\e9f5";
}
.pi-arrows-alt:before {
  content: "\e9f0";
}
.pi-calculator:before {
  content: "\e9ef";
}
.pi-sort-alt-slash:before {
  content: "\e9ee";
}
.pi-arrows-h:before {
  content: "\e9ec";
}
.pi-arrows-v:before {
  content: "\e9ed";
}
.pi-pound:before {
  content: "\e9eb";
}
.pi-prime:before {
  content: "\e9ea";
}
.pi-chart-pie:before {
  content: "\e9e9";
}
.pi-reddit:before {
  content: "\e9e8";
}
.pi-code:before {
  content: "\e9e7";
}
.pi-sync:before {
  content: "\e9e6";
}
.pi-shopping-bag:before {
  content: "\e9e5";
}
.pi-server:before {
  content: "\e9e4";
}
.pi-database:before {
  content: "\e9e3";
}
.pi-hashtag:before {
  content: "\e9e2";
}
.pi-bookmark-fill:before {
  content: "\e9df";
}
.pi-filter-fill:before {
  content: "\e9e0";
}
.pi-heart-fill:before {
  content: "\e9e1";
}
.pi-flag-fill:before {
  content: "\e9de";
}
.pi-circle:before {
  content: "\e9dc";
}
.pi-circle-fill:before {
  content: "\e9dd";
}
.pi-bolt:before {
  content: "\e9db";
}
.pi-history:before {
  content: "\e9da";
}
.pi-box:before {
  content: "\e9d9";
}
.pi-at:before {
  content: "\e9d8";
}
.pi-arrow-up-right:before {
  content: "\e9d4";
}
.pi-arrow-up-left:before {
  content: "\e9d5";
}
.pi-arrow-down-left:before {
  content: "\e9d6";
}
.pi-arrow-down-right:before {
  content: "\e9d7";
}
.pi-telegram:before {
  content: "\e9d3";
}
.pi-stop-circle:before {
  content: "\e9d2";
}
.pi-stop:before {
  content: "\e9d1";
}
.pi-whatsapp:before {
  content: "\e9d0";
}
.pi-building:before {
  content: "\e9cf";
}
.pi-qrcode:before {
  content: "\e9ce";
}
.pi-car:before {
  content: "\e9cd";
}
.pi-instagram:before {
  content: "\e9cc";
}
.pi-linkedin:before {
  content: "\e9cb";
}
.pi-send:before {
  content: "\e9ca";
}
.pi-slack:before {
  content: "\e9c9";
}
.pi-sun:before {
  content: "\e9c8";
}
.pi-moon:before {
  content: "\e9c7";
}
.pi-vimeo:before {
  content: "\e9c6";
}
.pi-youtube:before {
  content: "\e9c5";
}
.pi-flag:before {
  content: "\e9c4";
}
.pi-wallet:before {
  content: "\e9c3";
}
.pi-map:before {
  content: "\e9c2";
}
.pi-link:before {
  content: "\e9c1";
}
.pi-credit-card:before {
  content: "\e9bf";
}
.pi-discord:before {
  content: "\e9c0";
}
.pi-percentage:before {
  content: "\e9be";
}
.pi-euro:before {
  content: "\e9bd";
}
.pi-book:before {
  content: "\e9ba";
}
.pi-shield:before {
  content: "\e9b9";
}
.pi-paypal:before {
  content: "\e9bb";
}
.pi-amazon:before {
  content: "\e9bc";
}
.pi-phone:before {
  content: "\e9b8";
}
.pi-filter-slash:before {
  content: "\e9b7";
}
.pi-facebook:before {
  content: "\e9b4";
}
.pi-github:before {
  content: "\e9b5";
}
.pi-twitter:before {
  content: "\e9b6";
}
.pi-step-backward-alt:before {
  content: "\e9ac";
}
.pi-step-forward-alt:before {
  content: "\e9ad";
}
.pi-forward:before {
  content: "\e9ae";
}
.pi-backward:before {
  content: "\e9af";
}
.pi-fast-backward:before {
  content: "\e9b0";
}
.pi-fast-forward:before {
  content: "\e9b1";
}
.pi-pause:before {
  content: "\e9b2";
}
.pi-play:before {
  content: "\e9b3";
}
.pi-compass:before {
  content: "\e9ab";
}
.pi-id-card:before {
  content: "\e9aa";
}
.pi-ticket:before {
  content: "\e9a9";
}
.pi-file-o:before {
  content: "\e9a8";
}
.pi-reply:before {
  content: "\e9a7";
}
.pi-directions-alt:before {
  content: "\e9a5";
}
.pi-directions:before {
  content: "\e9a6";
}
.pi-thumbs-up:before {
  content: "\e9a3";
}
.pi-thumbs-down:before {
  content: "\e9a4";
}
.pi-sort-numeric-down-alt:before {
  content: "\e996";
}
.pi-sort-numeric-up-alt:before {
  content: "\e997";
}
.pi-sort-alpha-down-alt:before {
  content: "\e998";
}
.pi-sort-alpha-up-alt:before {
  content: "\e999";
}
.pi-sort-numeric-down:before {
  content: "\e99a";
}
.pi-sort-numeric-up:before {
  content: "\e99b";
}
.pi-sort-alpha-down:before {
  content: "\e99c";
}
.pi-sort-alpha-up:before {
  content: "\e99d";
}
.pi-sort-alt:before {
  content: "\e99e";
}
.pi-sort-amount-up:before {
  content: "\e99f";
}
.pi-sort-amount-down:before {
  content: "\e9a0";
}
.pi-sort-amount-down-alt:before {
  content: "\e9a1";
}
.pi-sort-amount-up-alt:before {
  content: "\e9a2";
}
.pi-palette:before {
  content: "\e995";
}
.pi-undo:before {
  content: "\e994";
}
.pi-desktop:before {
  content: "\e993";
}
.pi-sliders-v:before {
  content: "\e991";
}
.pi-sliders-h:before {
  content: "\e992";
}
.pi-search-plus:before {
  content: "\e98f";
}
.pi-search-minus:before {
  content: "\e990";
}
.pi-file-excel:before {
  content: "\e98e";
}
.pi-file-pdf:before {
  content: "\e98d";
}
.pi-check-square:before {
  content: "\e98c";
}
.pi-chart-line:before {
  content: "\e98b";
}
.pi-user-edit:before {
  content: "\e98a";
}
.pi-exclamation-circle:before {
  content: "\e989";
}
.pi-android:before {
  content: "\e985";
}
.pi-google:before {
  content: "\e986";
}
.pi-apple:before {
  content: "\e987";
}
.pi-microsoft:before {
  content: "\e988";
}
.pi-heart:before {
  content: "\e984";
}
.pi-mobile:before {
  content: "\e982";
}
.pi-tablet:before {
  content: "\e983";
}
.pi-key:before {
  content: "\e981";
}
.pi-shopping-cart:before {
  content: "\e980";
}
.pi-comments:before {
  content: "\e97e";
}
.pi-comment:before {
  content: "\e97f";
}
.pi-briefcase:before {
  content: "\e97d";
}
.pi-bell:before {
  content: "\e97c";
}
.pi-paperclip:before {
  content: "\e97b";
}
.pi-share-alt:before {
  content: "\e97a";
}
.pi-envelope:before {
  content: "\e979";
}
.pi-volume-down:before {
  content: "\e976";
}
.pi-volume-up:before {
  content: "\e977";
}
.pi-volume-off:before {
  content: "\e978";
}
.pi-eject:before {
  content: "\e975";
}
.pi-money-bill:before {
  content: "\e974";
}
.pi-images:before {
  content: "\e973";
}
.pi-image:before {
  content: "\e972";
}
.pi-sign-in:before {
  content: "\e970";
}
.pi-sign-out:before {
  content: "\e971";
}
.pi-wifi:before {
  content: "\e96f";
}
.pi-sitemap:before {
  content: "\e96e";
}
.pi-chart-bar:before {
  content: "\e96d";
}
.pi-camera:before {
  content: "\e96c";
}
.pi-dollar:before {
  content: "\e96b";
}
.pi-lock-open:before {
  content: "\e96a";
}
.pi-table:before {
  content: "\e969";
}
.pi-map-marker:before {
  content: "\e968";
}
.pi-list:before {
  content: "\e967";
}
.pi-eye-slash:before {
  content: "\e965";
}
.pi-eye:before {
  content: "\e966";
}
.pi-folder-open:before {
  content: "\e964";
}
.pi-folder:before {
  content: "\e963";
}
.pi-video:before {
  content: "\e962";
}
.pi-inbox:before {
  content: "\e961";
}
.pi-lock:before {
  content: "\e95f";
}
.pi-unlock:before {
  content: "\e960";
}
.pi-tags:before {
  content: "\e95d";
}
.pi-tag:before {
  content: "\e95e";
}
.pi-power-off:before {
  content: "\e95c";
}
.pi-save:before {
  content: "\e95b";
}
.pi-question-circle:before {
  content: "\e959";
}
.pi-question:before {
  content: "\e95a";
}
.pi-copy:before {
  content: "\e957";
}
.pi-file:before {
  content: "\e958";
}
.pi-clone:before {
  content: "\e955";
}
.pi-calendar-times:before {
  content: "\e952";
}
.pi-calendar-minus:before {
  content: "\e953";
}
.pi-calendar-plus:before {
  content: "\e954";
}
.pi-ellipsis-v:before {
  content: "\e950";
}
.pi-ellipsis-h:before {
  content: "\e951";
}
.pi-bookmark:before {
  content: "\e94e";
}
.pi-globe:before {
  content: "\e94f";
}
.pi-replay:before {
  content: "\e94d";
}
.pi-filter:before {
  content: "\e94c";
}
.pi-print:before {
  content: "\e94b";
}
.pi-align-right:before {
  content: "\e946";
}
.pi-align-left:before {
  content: "\e947";
}
.pi-align-center:before {
  content: "\e948";
}
.pi-align-justify:before {
  content: "\e949";
}
.pi-cog:before {
  content: "\e94a";
}
.pi-cloud-download:before {
  content: "\e943";
}
.pi-cloud-upload:before {
  content: "\e944";
}
.pi-cloud:before {
  content: "\e945";
}
.pi-pencil:before {
  content: "\e942";
}
.pi-users:before {
  content: "\e941";
}
.pi-clock:before {
  content: "\e940";
}
.pi-user-minus:before {
  content: "\e93e";
}
.pi-user-plus:before {
  content: "\e93f";
}
.pi-trash:before {
  content: "\e93d";
}
.pi-external-link:before {
  content: "\e93c";
}
.pi-window-maximize:before {
  content: "\e93b";
}
.pi-window-minimize:before {
  content: "\e93a";
}
.pi-refresh:before {
  content: "\e938";
}
.pi-user:before {
  content: "\e939";
}
.pi-exclamation-triangle:before {
  content: "\e922";
}
.pi-calendar:before {
  content: "\e927";
}
.pi-chevron-circle-left:before {
  content: "\e928";
}
.pi-chevron-circle-down:before {
  content: "\e929";
}
.pi-chevron-circle-right:before {
  content: "\e92a";
}
.pi-chevron-circle-up:before {
  content: "\e92b";
}
.pi-angle-double-down:before {
  content: "\e92c";
}
.pi-angle-double-left:before {
  content: "\e92d";
}
.pi-angle-double-right:before {
  content: "\e92e";
}
.pi-angle-double-up:before {
  content: "\e92f";
}
.pi-angle-down:before {
  content: "\e930";
}
.pi-angle-left:before {
  content: "\e931";
}
.pi-angle-right:before {
  content: "\e932";
}
.pi-angle-up:before {
  content: "\e933";
}
.pi-upload:before {
  content: "\e934";
}
.pi-download:before {
  content: "\e956";
}
.pi-ban:before {
  content: "\e935";
}
.pi-star-fill:before {
  content: "\e936";
}
.pi-star:before {
  content: "\e937";
}
.pi-chevron-left:before {
  content: "\e900";
}
.pi-chevron-right:before {
  content: "\e901";
}
.pi-chevron-down:before {
  content: "\e902";
}
.pi-chevron-up:before {
  content: "\e903";
}
.pi-caret-left:before {
  content: "\e904";
}
.pi-caret-right:before {
  content: "\e905";
}
.pi-caret-down:before {
  content: "\e906";
}
.pi-caret-up:before {
  content: "\e907";
}
.pi-search:before {
  content: "\e908";
}
.pi-check:before {
  content: "\e909";
}
.pi-check-circle:before {
  content: "\e90a";
}
.pi-times:before {
  content: "\e90b";
}
.pi-times-circle:before {
  content: "\e90c";
}
.pi-plus:before {
  content: "\e90d";
}
.pi-plus-circle:before {
  content: "\e90e";
}
.pi-minus:before {
  content: "\e90f";
}
.pi-minus-circle:before {
  content: "\e910";
}
.pi-circle-on:before {
  content: "\e911";
}
.pi-circle-off:before {
  content: "\e912";
}
.pi-sort-down:before {
  content: "\e913";
}
.pi-sort-up:before {
  content: "\e914";
}
.pi-sort:before {
  content: "\e915";
}
.pi-step-backward:before {
  content: "\e916";
}
.pi-step-forward:before {
  content: "\e917";
}
.pi-th-large:before {
  content: "\e918";
}
.pi-arrow-down:before {
  content: "\e919";
}
.pi-arrow-left:before {
  content: "\e91a";
}
.pi-arrow-right:before {
  content: "\e91b";
}
.pi-arrow-up:before {
  content: "\e91c";
}
.pi-bars:before {
  content: "\e91d";
}
.pi-arrow-circle-down:before {
  content: "\e91e";
}
.pi-arrow-circle-left:before {
  content: "\e91f";
}
.pi-arrow-circle-right:before {
  content: "\e920";
}
.pi-arrow-circle-up:before {
  content: "\e921";
}
.pi-info:before {
  content: "\e923";
}
.pi-info-circle:before {
  content: "\e924";
}
.pi-home:before {
  content: "\e925";
}
.pi-spinner:before {
  content: "\e926";
}
pre.app-code {
  background-color: var(--surface-ground);
  margin: 0 0 1rem 0;
  padding: 0;
  border-radius: var(--border-radius);
  overflow: auto;
}
pre.app-code code {
  color: var(--text-color);
  padding: 1rem;
  line-height: 1.5;
  display: block;
  font-family:
    monaco,
    Consolas,
    monospace;
}
span.flag {
  width: 44px;
  height: 30px;
  display: inline-block;
}
img.flag {
  width: 30px;
}
.flag {
  background: url(https://primefaces.org/cdn/primevue/images/flag/flags_responsive.png) no-repeat;
  background-size: 100%;
  vertical-align: middle;
}
.flag-ad {
  background-position: 0 0.413223%;
}
.flag-ae {
  background-position: 0 0.826446%;
}
.flag-af {
  background-position: 0 1.239669%;
}
.flag-ag {
  background-position: 0 1.652893%;
}
.flag-ai {
  background-position: 0 2.066116%;
}
.flag-al {
  background-position: 0 2.479339%;
}
.flag-am {
  background-position: 0 2.892562%;
}
.flag-an {
  background-position: 0 3.305785%;
}
.flag-ao {
  background-position: 0 3.719008%;
}
.flag-aq {
  background-position: 0 4.132231%;
}
.flag-ar {
  background-position: 0 4.545455%;
}
.flag-as {
  background-position: 0 4.958678%;
}
.flag-at {
  background-position: 0 5.371901%;
}
.flag-au {
  background-position: 0 5.785124%;
}
.flag-aw {
  background-position: 0 6.198347%;
}
.flag-az {
  background-position: 0 6.61157%;
}
.flag-ba {
  background-position: 0 7.024793%;
}
.flag-bb {
  background-position: 0 7.438017%;
}
.flag-bd {
  background-position: 0 7.85124%;
}
.flag-be {
  background-position: 0 8.264463%;
}
.flag-bf {
  background-position: 0 8.677686%;
}
.flag-bg {
  background-position: 0 9.090909%;
}
.flag-bh {
  background-position: 0 9.504132%;
}
.flag-bi {
  background-position: 0 9.917355%;
}
.flag-bj {
  background-position: 0 10.330579%;
}
.flag-bm {
  background-position: 0 10.743802%;
}
.flag-bn {
  background-position: 0 11.157025%;
}
.flag-bo {
  background-position: 0 11.570248%;
}
.flag-br {
  background-position: 0 11.983471%;
}
.flag-bs {
  background-position: 0 12.396694%;
}
.flag-bt {
  background-position: 0 12.809917%;
}
.flag-bv {
  background-position: 0 13.22314%;
}
.flag-bw {
  background-position: 0 13.636364%;
}
.flag-by {
  background-position: 0 14.049587%;
}
.flag-bz {
  background-position: 0 14.46281%;
}
.flag-ca {
  background-position: 0 14.876033%;
}
.flag-cc {
  background-position: 0 15.289256%;
}
.flag-cd {
  background-position: 0 15.702479%;
}
.flag-cf {
  background-position: 0 16.115702%;
}
.flag-cg {
  background-position: 0 16.528926%;
}
.flag-ch {
  background-position: 0 16.942149%;
}
.flag-ci {
  background-position: 0 17.355372%;
}
.flag-ck {
  background-position: 0 17.768595%;
}
.flag-cl {
  background-position: 0 18.181818%;
}
.flag-cm {
  background-position: 0 18.595041%;
}
.flag-cn {
  background-position: 0 19.008264%;
}
.flag-co {
  background-position: 0 19.421488%;
}
.flag-cr {
  background-position: 0 19.834711%;
}
.flag-cu {
  background-position: 0 20.247934%;
}
.flag-cv {
  background-position: 0 20.661157%;
}
.flag-cx {
  background-position: 0 21.07438%;
}
.flag-cy {
  background-position: 0 21.487603%;
}
.flag-cz {
  background-position: 0 21.900826%;
}
.flag-de {
  background-position: 0 22.31405%;
}
.flag-dj {
  background-position: 0 22.727273%;
}
.flag-dk {
  background-position: 0 23.140496%;
}
.flag-dm {
  background-position: 0 23.553719%;
}
.flag-do {
  background-position: 0 23.966942%;
}
.flag-dz {
  background-position: 0 24.380165%;
}
.flag-ec {
  background-position: 0 24.793388%;
}
.flag-ee {
  background-position: 0 25.206612%;
}
.flag-eg {
  background-position: 0 25.619835%;
}
.flag-eh {
  background-position: 0 26.033058%;
}
.flag-er {
  background-position: 0 26.446281%;
}
.flag-es {
  background-position: 0 26.859504%;
}
.flag-et {
  background-position: 0 27.272727%;
}
.flag-fi {
  background-position: 0 27.68595%;
}
.flag-fj {
  background-position: 0 28.099174%;
}
.flag-fk {
  background-position: 0 28.512397%;
}
.flag-fm {
  background-position: 0 28.92562%;
}
.flag-fo {
  background-position: 0 29.338843%;
}
.flag-fr {
  background-position: 0 29.752066%;
}
.flag-ga {
  background-position: 0 30.165289%;
}
.flag-gd {
  background-position: 0 30.578512%;
}
.flag-ge {
  background-position: 0 30.991736%;
}
.flag-gf {
  background-position: 0 31.404959%;
}
.flag-gh {
  background-position: 0 31.818182%;
}
.flag-gi {
  background-position: 0 32.231405%;
}
.flag-gl {
  background-position: 0 32.644628%;
}
.flag-gm {
  background-position: 0 33.057851%;
}
.flag-gn {
  background-position: 0 33.471074%;
}
.flag-gp {
  background-position: 0 33.884298%;
}
.flag-gq {
  background-position: 0 34.297521%;
}
.flag-gr {
  background-position: 0 34.710744%;
}
.flag-gs {
  background-position: 0 35.123967%;
}
.flag-gt {
  background-position: 0 35.53719%;
}
.flag-gu {
  background-position: 0 35.950413%;
}
.flag-gw {
  background-position: 0 36.363636%;
}
.flag-gy {
  background-position: 0 36.77686%;
}
.flag-hk {
  background-position: 0 37.190083%;
}
.flag-hm {
  background-position: 0 37.603306%;
}
.flag-hn {
  background-position: 0 38.016529%;
}
.flag-hr {
  background-position: 0 38.429752%;
}
.flag-ht {
  background-position: 0 38.842975%;
}
.flag-hu {
  background-position: 0 39.256198%;
}
.flag-id {
  background-position: 0 39.669421%;
}
.flag-ie {
  background-position: 0 40.082645%;
}
.flag-il {
  background-position: 0 40.495868%;
}
.flag-in {
  background-position: 0 40.909091%;
}
.flag-io {
  background-position: 0 41.322314%;
}
.flag-iq {
  background-position: 0 41.735537%;
}
.flag-ir {
  background-position: 0 42.14876%;
}
.flag-is {
  background-position: 0 42.561983%;
}
.flag-it {
  background-position: 0 42.975207%;
}
.flag-jm {
  background-position: 0 43.38843%;
}
.flag-jo {
  background-position: 0 43.801653%;
}
.flag-jp {
  background-position: 0 44.214876%;
}
.flag-ke {
  background-position: 0 44.628099%;
}
.flag-kg {
  background-position: 0 45.041322%;
}
.flag-kh {
  background-position: 0 45.454545%;
}
.flag-ki {
  background-position: 0 45.867769%;
}
.flag-km {
  background-position: 0 46.280992%;
}
.flag-kn {
  background-position: 0 46.694215%;
}
.flag-kp {
  background-position: 0 47.107438%;
}
.flag-kr {
  background-position: 0 47.520661%;
}
.flag-kw {
  background-position: 0 47.933884%;
}
.flag-ky {
  background-position: 0 48.347107%;
}
.flag-kz {
  background-position: 0 48.760331%;
}
.flag-la {
  background-position: 0 49.173554%;
}
.flag-lb {
  background-position: 0 49.586777%;
}
.flag-lc {
  background-position: 0 50%;
}
.flag-li {
  background-position: 0 50.413223%;
}
.flag-lk {
  background-position: 0 50.826446%;
}
.flag-lr {
  background-position: 0 51.239669%;
}
.flag-ls {
  background-position: 0 51.652893%;
}
.flag-lt {
  background-position: 0 52.066116%;
}
.flag-lu {
  background-position: 0 52.479339%;
}
.flag-lv {
  background-position: 0 52.892562%;
}
.flag-ly {
  background-position: 0 53.305785%;
}
.flag-ma {
  background-position: 0 53.719008%;
}
.flag-mc {
  background-position: 0 54.132231%;
}
.flag-md {
  background-position: 0 54.545455%;
}
.flag-me {
  background-position: 0 54.958678%;
}
.flag-mg {
  background-position: 0 55.371901%;
}
.flag-mh {
  background-position: 0 55.785124%;
}
.flag-mk {
  background-position: 0 56.198347%;
}
.flag-ml {
  background-position: 0 56.61157%;
}
.flag-mm {
  background-position: 0 57.024793%;
}
.flag-mn {
  background-position: 0 57.438017%;
}
.flag-mo {
  background-position: 0 57.85124%;
}
.flag-mp {
  background-position: 0 58.264463%;
}
.flag-mq {
  background-position: 0 58.677686%;
}
.flag-mr {
  background-position: 0 59.090909%;
}
.flag-ms {
  background-position: 0 59.504132%;
}
.flag-mt {
  background-position: 0 59.917355%;
}
.flag-mu {
  background-position: 0 60.330579%;
}
.flag-mv {
  background-position: 0 60.743802%;
}
.flag-mw {
  background-position: 0 61.157025%;
}
.flag-mx {
  background-position: 0 61.570248%;
}
.flag-my {
  background-position: 0 61.983471%;
}
.flag-mz {
  background-position: 0 62.396694%;
}
.flag-na {
  background-position: 0 62.809917%;
}
.flag-nc {
  background-position: 0 63.22314%;
}
.flag-ne {
  background-position: 0 63.636364%;
}
.flag-nf {
  background-position: 0 64.049587%;
}
.flag-ng {
  background-position: 0 64.46281%;
}
.flag-ni {
  background-position: 0 64.876033%;
}
.flag-nl {
  background-position: 0 65.289256%;
}
.flag-no {
  background-position: 0 65.702479%;
}
.flag-np {
  background-position: 0 66.115702%;
}
.flag-nr {
  background-position: 0 66.528926%;
}
.flag-nu {
  background-position: 0 66.942149%;
}
.flag-nz {
  background-position: 0 67.355372%;
}
.flag-om {
  background-position: 0 67.768595%;
}
.flag-pa {
  background-position: 0 68.181818%;
}
.flag-pe {
  background-position: 0 68.595041%;
}
.flag-pf {
  background-position: 0 69.008264%;
}
.flag-pg {
  background-position: 0 69.421488%;
}
.flag-ph {
  background-position: 0 69.834711%;
}
.flag-pk {
  background-position: 0 70.247934%;
}
.flag-pl {
  background-position: 0 70.661157%;
}
.flag-pm {
  background-position: 0 71.07438%;
}
.flag-pn {
  background-position: 0 71.487603%;
}
.flag-pr {
  background-position: 0 71.900826%;
}
.flag-pt {
  background-position: 0 72.31405%;
}
.flag-pw {
  background-position: 0 72.727273%;
}
.flag-py {
  background-position: 0 73.140496%;
}
.flag-qa {
  background-position: 0 73.553719%;
}
.flag-re {
  background-position: 0 73.966942%;
}
.flag-ro {
  background-position: 0 74.380165%;
}
.flag-rs {
  background-position: 0 74.793388%;
}
.flag-ru {
  background-position: 0 75.206612%;
}
.flag-rw {
  background-position: 0 75.619835%;
}
.flag-sa {
  background-position: 0 76.033058%;
}
.flag-sb {
  background-position: 0 76.446281%;
}
.flag-sc {
  background-position: 0 76.859504%;
}
.flag-sd {
  background-position: 0 77.272727%;
}
.flag-se {
  background-position: 0 77.68595%;
}
.flag-sg {
  background-position: 0 78.099174%;
}
.flag-sh {
  background-position: 0 78.512397%;
}
.flag-si {
  background-position: 0 78.92562%;
}
.flag-sj {
  background-position: 0 79.338843%;
}
.flag-sk {
  background-position: 0 79.752066%;
}
.flag-sl {
  background-position: 0 80.165289%;
}
.flag-sm {
  background-position: 0 80.578512%;
}
.flag-sn {
  background-position: 0 80.991736%;
}
.flag-so {
  background-position: 0 81.404959%;
}
.flag-sr {
  background-position: 0 81.818182%;
}
.flag-ss {
  background-position: 0 82.231405%;
}
.flag-st {
  background-position: 0 82.644628%;
}
.flag-sv {
  background-position: 0 83.057851%;
}
.flag-sy {
  background-position: 0 83.471074%;
}
.flag-sz {
  background-position: 0 83.884298%;
}
.flag-tc {
  background-position: 0 84.297521%;
}
.flag-td {
  background-position: 0 84.710744%;
}
.flag-tf {
  background-position: 0 85.123967%;
}
.flag-tg {
  background-position: 0 85.53719%;
}
.flag-th {
  background-position: 0 85.950413%;
}
.flag-tj {
  background-position: 0 86.363636%;
}
.flag-tk {
  background-position: 0 86.77686%;
}
.flag-tl {
  background-position: 0 87.190083%;
}
.flag-tm {
  background-position: 0 87.603306%;
}
.flag-tn {
  background-position: 0 88.016529%;
}
.flag-to {
  background-position: 0 88.429752%;
}
.flag-tp {
  background-position: 0 88.842975%;
}
.flag-tr {
  background-position: 0 89.256198%;
}
.flag-tt {
  background-position: 0 89.669421%;
}
.flag-tv {
  background-position: 0 90.082645%;
}
.flag-tw {
  background-position: 0 90.495868%;
}
.flag-ty {
  background-position: 0 90.909091%;
}
.flag-tz {
  background-position: 0 91.322314%;
}
.flag-ua {
  background-position: 0 91.735537%;
}
.flag-ug {
  background-position: 0 92.14876%;
}
.flag-gb,
.flag-uk {
  background-position: 0 92.561983%;
}
.flag-um {
  background-position: 0 92.975207%;
}
.flag-us {
  background-position: 0 93.38843%;
}
.flag-uy {
  background-position: 0 93.801653%;
}
.flag-uz {
  background-position: 0 94.214876%;
}
.flag-va {
  background-position: 0 94.628099%;
}
.flag-vc {
  background-position: 0 95.041322%;
}
.flag-ve {
  background-position: 0 95.454545%;
}
.flag-vg {
  background-position: 0 95.867769%;
}
.flag-vi {
  background-position: 0 96.280992%;
}
.flag-vn {
  background-position: 0 96.694215%;
}
.flag-vu {
  background-position: 0 97.107438%;
}
.flag-wf {
  background-position: 0 97.520661%;
}
.flag-ws {
  background-position: 0 97.933884%;
}
.flag-ye {
  background-position: 0 98.347107%;
}
.flag-za {
  background-position: 0 98.760331%;
}
.flag-zm {
  background-position: 0 99.173554%;
}
.flag-zr {
  background-position: 0 99.586777%;
}
.flag-zw {
  background-position: 0 100%;
}
body#themeTag :host ::ng-deep .p-ripple.p-button.p-component.p-button-icon-only.p-button-secondary.p-button-rounded.p-button-text {
  color: red !important;
}
.ef-message {
  background-color: var(--surface-card, var(--p-content-background, #ffffff)) !important;
  color: var(--text-color, var(--p-text-color, #333333)) !important;
  box-shadow: var(--p-overlay-shadow, 0 2px 8px rgba(0, 0, 0, 0.1)) !important;
  border: 1px solid var(--surface-border, var(--p-content-border-color, #e0e0e0)) !important;
  border-radius: var(--border-radius, var(--p-content-border-radius, 8px)) !important;
  padding: 1.5rem !important;
  margin-bottom: 1rem !important;
  position: relative !important;
  z-index: 1 !important;
}
:host-context(.dark-theme) .ef-message {
  background-color: var(--surface-card, var(--p-surface-800, #2d2d2d)) !important;
  color: var(--text-color, var(--p-text-color, #ffffff)) !important;
  border-color: var(--surface-border, var(--p-surface-600, #444444)) !important;
}
:host ::ng-deep .ef-message {
  background-color: var(--surface-card, var(--p-content-background, #ffffff)) !important;
  color: var(--text-color, var(--p-text-color, #333333)) !important;
  box-shadow: var(--p-overlay-shadow, 0 2px 8px rgba(0, 0, 0, 0.1)) !important;
  border: 1px solid var(--surface-border, var(--p-content-border-color, #e0e0e0)) !important;
  border-radius: var(--border-radius, var(--p-content-border-radius, 8px)) !important;
  padding: 1.5rem !important;
  margin-bottom: 1rem !important;
  position: relative !important;
  z-index: 1 !important;
  min-height: 50px !important;
  display: block !important;
}
:host ::ng-deep div[class*=ef-message] {
  background-color: var(--surface-card, var(--p-surface-0, #f8f9fa)) !important;
  border: 2px solid var(--primary-color, var(--p-primary-color, #007bff)) !important;
  border-radius: var(--border-radius, var(--p-content-border-radius, 8px)) !important;
  padding: 1rem !important;
  margin: 0.5rem 0 !important;
}
.ef-menuitem-badge-on a > span {
  float: right;
  width: auto;
  margin-right: 2px;
  text-align: center;
  background-color: #FF0000;
  color: #FFFFFF;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  border-radius: 3px;
  padding: 1px 5px;
  margin-top: -2.4em;
  margin-right: -0.1em;
  position: relative;
}
.ef-menuitem-badge-off a > span {
  display: none;
}
/*# sourceMappingURL=app.message.css.map */
